// 销售统计
export default {
    heard_title: "销售统计",
    nav_title: "项目名称销售分析",
    fl_store: "门店选择",
    fp_store: "请选择门店",
    btn_exportData: "导出数据",
    radio_lastWeek: "最近7天",
    radio_lastMonth: "最近30天",
    radio_threeMouth: "最近90天",
    fp_endTime: "结束日期",
    fp_startTime: "开始日期",

    // table
    tl_projectName: "项目名称",
    tl_inventoryQuantity: "库存数量",
    tl_quantity: "销售数量",
    tl_soldOutPercentage: "告罄率",
    tl_quantityPercentage: "数量比例",
    tl_amount: "销售金额",
    tl_amountPercentage: "金额比例",

    // 商品销售情况
    nav_shopSales: "商品销售情况",
    // 其他同上

    tl_productName: "商品名称",
    tl_pQuantity: "销售数量",
    tl_pAmount: "销售金额",
    tl_pAmountPercentage: "金额占比"
};
